import { render, staticRenderFns } from "./SplitGridGutter.vue?vue&type=template&id=a6ac4e44&scoped=true&"
import script from "./SplitGridGutter.vue?vue&type=script&lang=js&"
export * from "./SplitGridGutter.vue?vue&type=script&lang=js&"
import style0 from "./SplitGridGutter.vue?vue&type=style&index=0&id=a6ac4e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ac4e44",
  null
  
)

export default component.exports